import { Box, Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import he from 'he';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { useResponsive } from '@/components/hooks/useResponsive';
import { ZipCodeConversion } from '@/components/feature/searchDirectory/ZipCodeConversion';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { useLDClientFlags } from '@/components/hooks/useLDClientFlags';
import { LaunchDarklyEvaluationReasons, UI_FEATURE_FLAGS } from '@/constants';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

export const HeroConversionBox = () => {
  const pageData = useSearchDirectoryData();
  const { isLargeViewport } = useResponsive();
  const { serviceIdForMember, pageType } = usePageAttributes();
  const { headline, subHeadline } = pageData.seoSegmentationDetails;
  const ctaText = 'Start matching';
  const { DAYCARE_DIRECTORY_FIRST_FLOW: daycareDirectoryFirstFlag } = useLDClientFlags();

  const handleCtaBtn = () => {
    const amplitudeData = {
      cta_text: ctaText,
      cta_type: 'button',
    };

    if (
      daycareDirectoryFirstFlag &&
      daycareDirectoryFirstFlag.reason.kind === LaunchDarklyEvaluationReasons.RULE_MATCH
    ) {
      trackAmplitudeEvent(AmplitudeEvent.testExposure, {
        test_name: UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id,
        test_variant: daycareDirectoryFirstFlag.variationIndex,
        service_id_for_member: serviceIdForMember,
        page_template: pageType,
      });
    }

    trackAmplitudeEvent('CTA Interacted', amplitudeData);
  };

  return (
    <Box
      sx={{
        mb: { xs: 6, sm: 0 },
      }}>
      <Typography
        component="h1"
        variant={isLargeViewport ? 'display1' : 'display2'}
        color="primary"
        sx={{
          mb: { xs: 2, sm: 3 },
          mt: 0,
        }}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(he.decode(headline)),
        }}
      />
      <Typography
        component="p"
        variant="body2"
        mb={4}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(he.decode(subHeadline.replace(/<\/?p>/g, ''))),
        }}
      />
      <ZipCodeConversion
        showZipCodeInputField
        handleCtaBtn={handleCtaBtn}
        ctaText={ctaText}
        isDirectoryFirstExperience
      />
    </Box>
  );
};
